<template>
  <a-spin :spinning="spinning" tip="加载中...">
    <div class="top-title" @click="lastStep"><a-icon type="left" /> 智能监测</div>
    <div class="card-value-class">
      <a-row :gutter="[0, 15]">
        <a-col :span="24">
          <div class="all-card">
            <a-card :bordered="false">
              <div class="title-div-class">
                近24小时使用频次
              </div>
              <div id="runbyhourstatic"></div>
            </a-card>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="all-card">
            <a-card :bordered="false">
              <div class="title-div-class">
                近30天电梯疲劳度数据
              </div>
              <a-col :span="12">
                <div class="title-div-value"><img src="~@/assets/new-images/runtime.png"/> 运行时间（小时）</div>
                <div class="div-value">{{ runData.runDuration ? runTimeInterval(runData.runDuration) : '-' }}</div>
              </a-col>
              <a-col :span="12">
                <div class="title-div-value"><img src="~@/assets/new-images/rundentice.png"/> 运行距离（层）</div>
                <div class="div-value">{{ runData.moveFloorsCount ? runData.moveFloorsCount : '-' }}</div>
              </a-col>
              <a-col :span="12">
                <div class="title-div-value"><img src="~@/assets/new-images/runcount.png"/> 运行次数</div>
                <div class="div-value">{{ runData.runCount ? runData.runCount : '-' }}</div>
              </a-col>
              <a-col :span="12">
                <div class="title-div-value"><img src="~@/assets/new-images/doorcount.png"/> 开门次数</div>
                <div class="div-value">{{ runData.doorOpenCount ? runData.doorOpenCount : '-' }}</div>
              </a-col>
              <a-col :span="12">
                <div class="title-div-value"><img src="~@/assets/new-images/bandcount.png"/> 钢丝绳弯折次数</div>
                <div class="div-value">{{ runData.cableBendCount ? runData.cableBendCount : '-' }}</div>
              </a-col>
            </a-card>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="all-card">
            <a-card :bordered="false">
              <div class="title-div-class">
                近30天日均用梯高峰
                <div class="time-class">{{rushhourTime}}</div>
              </div>
              <div id="dayslineecharts"></div>
            </a-card>
          </div>
        </a-col>
      </a-row>
    </div>
  </a-spin>
</template>

<script>
import axios from "axios";
import * as echarts from 'echarts'
export default {
  components: {},
  data() {
    return {
      record:{},
      spinning:false,
      daysX: [],
      runsdatas: [],
      datalines: [
        '0:00-0:30',
        '0:30-1:00',
        '1:00-1:30',
        '1:30-2:00',
        '2:00-2:30',
        '2:30-3:00',
        '3:00-3:30',
        '3:30-4:00',
        '4:00-4:30',
        '4:30-5:00',
        '5:00-5:30',
        '5:30-6:00',
        '6:00-6:30',
        '6:30-7:00',
        '7:00-7:30',
        '7:30-8:00',
        '8:00-8:30',
        '8:30-9:00',
        '9:00-9:30',
        '9:30-10:00',
        '10:00-10:30',
        '10:30-11:00',
        '11:00-11:30',
        '11:30-12:00',
        '12:00-12:30',
        '12:30-13:00',
        '13:00-13:30',
        '13:30-14:00',
        '14:00-14:30',
        '14:30-15:00',
        '15:00-15:30',
        '15:30-16:00',
        '16:00-16:30',
        '16:30-17:00',
        '17:00-17:30',
        '17:30-18:00',
        '18:00-18:30',
        '18:30-19:00',
        '19:00-19:30',
        '19:30-20:00',
        '20:00-20:30',
        '20:30-21:00',
        '21:00-21:30',
        '21:30-22:00',
        '22:00-22:30',
        '22:30-23:00',
        '23:00-23:30',
        '23:30-24:00'
      ],
      dataworklines: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      dataholidaylines: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      rushhourTime:'-',
      runData:{}
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        // 这里处理 query 参数变化的逻辑
        this.record = JSON.parse(newQuery.record)
      }
    }
  },
  created() {
    this.record = JSON.parse(this.$route.query.record)
    if (this.record){
      this.runbyhourstatic()
      this.runstatus()
      this.elevatorAverage()
    }
  },
  mounted() {
    this.daysX = [
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00',
      '00:00'
    ]
    this.runsdatas = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    this.$nextTick(() => {
      this.drawelecStatics()
      this.daysavgecharts()
    })
  },
  methods: {
    //使用频次查询
    runbyhourstatic() {
      let _this = this
      this.spinning = true
      let params = {}
      params.beginTime = _this.getTimestamp24HoursAgo()
      params.endTime = _this.getNearestPreviousHourTimestamp()
      params.elevId = _this.record.id
      params.pageNum = 1
      params.pageSize = 100
      axios.get(site.apiHost + "/elevator-public/elev-run-total-stats/page-by-elev-id", { params }).then(res => {
        if (res.data.errorCode == 0) {
          let data = res.data.data.list
          if (data.length > 0) {
            _this.daysX = [];
            _this.runsdatas = [];
            data.forEach((item) => {
              _this.daysX.push(_this.formatDate2(item.beginTime));
              _this.runsdatas.push(item.runTotal ? item.runTotal : 0);
            });
          }
        }
      }).catch(error => {}).finally(()=>{
        this.drawelecStatics()
        this.spinning = false
      })
    },
    //运行统计
    runstatus() {
      let _this = this
      this.spinning = true
      let params = {
        elevId: this.record.id,
        beginTime: new Date(new Date().toLocaleDateString()).getTime() - 86400000 * 29,
        endTime: new Date(new Date().toLocaleDateString()).getTime() + 86400000 - 1 //今天是01-05，查询的时间为01-04
      }
      axios.get(site.apiHost + "/elevator-public/elev-run-stats-sum/get-by-elev-id", { params }).then(res => {
        if (res.data.errorCode == 0) {
          _this.runData = res.data.data
        }
      }).catch(error => {}).finally(()=>{
        this.drawelecStatics()
        this.spinning = false
      })
    },
    //日均高峰时段
    elevatorAverage() {
      let _this = this
      this.spinning = true
      _this.dataworklines = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      //工作日
      let params = {
        elevId: this.record.id,
        dayType: 1,
        beginTime: new Date(new Date().toLocaleDateString()).getTime() - 86400000 * 29,
        endTime: new Date(new Date().toLocaleDateString()).getTime() + 86400000 - 1 //今天是01-05，查询的时间为01-04
      }
      axios.get(site.apiHost + "/elevator-public/elev-run-total-stats-average/get-by-elev-id", { params }).then(res => {
        if (res.data.errorCode == 0) {
          let data = res.data.data
          if (data.length > 0) {
            _this.rushhourTime = ''
            data.forEach(item => {
              let index = _this.datalines.findIndex(
                times => times == _this.putEro(item.msOfDayBegin, item.msOfDayEnd + 1)
              )
              if (index > -1) {
                _this.dataworklines[index] = item.total
              }
            })
            let datasort = data.sort(function(a, b) {
              return b.total - a.total
            })
            datasort.forEach((val, i) => {
              if (i < 4) {
                _this.rushhourTime = _this.putEro(val.msOfDayBegin, val.msOfDayEnd + 1) + '、' + _this.rushhourTime
              }
            })
          }else {
            _this.rushhourTime = '20:00-20:30、20:00-20:30、20:00-20:30、20:00-20:30'
          }
        }
      }).catch(error => {}).finally(()=>{
        this.elevatorAverage2()
        this.spinning = false
      })
    },
    elevatorAverage2() {
      let _this = this
      this.spinning = true
      _this.dataholidaylines = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      //节假日
      let params = {
        elevatorId: this.record.id,
        dayType: 2,
        beginTime: new Date(new Date().toLocaleDateString()).getTime() - 86400000 * 29,
        endTime: new Date(new Date().toLocaleDateString()).getTime() + 86400000 - 1
      }
      axios.get(site.apiHost + "/elevator-public/elev-run-total-stats-average/get-by-elev-id", { params }).then(res => {
        if (res.data.errorCode == 0) {
          let data = res.data.data
          if (data.length > 0) {
            data.forEach(item => {
              let index = _this.datalines.findIndex(
                times => times == _this.putEro(item.msOfDayBegin, item.msOfDayEnd + 1)
              )
              if (index > -1) {
                _this.dataholidaylines[index] = item.total
              }
            })
          }
        }
      }).catch(error => {}).finally(()=>{
        this.$nextTick(() => {
          this.daysavgecharts()
        })
        this.spinning = false
      })
    },
    getNearestPreviousHourTimestamp() {
      let now = new Date()
      now.setMinutes(0)
      now.setSeconds(0)
      now.setMilliseconds(0)
      return now.getTime() // 毫秒级别时间戳
    },
    getTimestamp24HoursAgo() {
      let now = new Date()
      now.setHours(now.getHours() - 24)
      now.setMinutes(0)
      now.setSeconds(0)
      now.setMilliseconds(0)
      return now.getTime() // 毫秒级别时间戳
    },
    //整数补0,有小数就变成：30
    putEro(num1, num2) {
      let time1 = num1 / 3600000,
        time2 = num2 / 3600000
      if (time1.toString().indexOf('.') !== -1) {
        time1 = Math.floor(time1) + ':30'
      } else {
        time1 = time1 + ':00'
      }
      if (time2.toString().indexOf('.') !== -1) {
        time2 = Math.floor(time2) + ':30'
      } else {
        time2 = time2 + ':00'
      }
      return time1 + '-' + time2
    },
    //使用频次
    drawelecStatics() {
      let myChart = echarts.init(document.getElementById('runbyhourstatic'))
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '5%',
          containLabel: true
        },
        xAxis: {
          data: this.daysX,
          axisTick: {
            show: false
          },
        },
        yAxis: {
          nameTextStyle: {
            color: 'white',
            fontSize: 14
          },
          axisLine: {
            show: true,
          },
          splitLine: {
            show: true,
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            //柱状图
            type: 'bar',
            name: '24小时使用频次',
            barWidth: 8,
            data: this.runsdatas,
            itemStyle: {
              color: '#70b603'
            }
          }
        ]
      })
      if (myChart) {
        myChart.resize()
        window.addEventListener('resize', () => {
          if (myChart) {
            myChart.resize()
          }
        })
      }
    },
    //日均高峰曲线
    daysavgecharts() {
      let myChart = echarts.init(document.getElementById('dayslineecharts'))
      let option = {
        legend: {
          data: ['工作日', '节假日'],
          bottom: '0',
          right: '5'
        },
        grid: {
          top: '3%',
          left: '3%',
          right: '3%',
          bottom: '12%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: this.datalines
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.dataworklines,
            symbol: 'none',
            name: '工作日',
            type: 'line',
            itemStyle: {
              color: '#5B8FF9'
            }
          },
          {
            data: this.dataholidaylines,
            symbol: 'none',
            name: '节假日',
            type: 'line',
            itemStyle: {
              color: '#5AD8A6'
            }
          }
        ]
      }
      myChart.setOption(option)
      if (myChart) {
        myChart.resize()
        window.addEventListener('resize', () => {
          if (myChart) {
            myChart.resize()
          }
        })
      }
    },
    formatDate2(timeStamp) {
      let time = new Date(Number(timeStamp)),
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        mm = time.getMinutes(),
        s = time.getSeconds();
      return this.addZero(m) + '.' + this.addZero(d) + ' ' + this.addZero(h) + ':' + this.addZero(mm);
    },
    addZero(num) {
      if (num < 10) return '0' + num;
      return num;
    },
    runTimeInterval(dateDiff) {
      return (dateDiff / 3600000).toFixed(0)
    },
    lastStep(){
      this.$router.back(-1); // 后退到上一页
    },
  }
};
</script>

<style lang="less" scoped>

/deep/ .ant-card {
  border-radius: 10px;
}
/deep/ .ant-card-body {
  padding: 15px;
  zoom: 1;
}
.title-div {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  color: #333333;
  padding-bottom: 10px;
}
.all-card{
  background: #FFFFFF;
  border-radius: 10px;
}
.top-title{
  background: #ff4d4f;
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #ffffff;
  padding: 0 10px;
  margin-bottom: 15px;
  cursor: pointer;
}
.card-value-class{
  margin: 0px 15px;
}
.cardBorder {
  font-size: 13px;
  text-align: left;
}
.cardBorder2 {
  font-size: 13px;
  text-align: left;
  margin: 0px 5px;
}
.cardBorder::after {
  content: "";
  position: absolute;
  right: 5px;
  top: 2px;
  width: 1px;
  background-color: #dddddd;
  height: 90%;
}
.value-num{
  font-size: 30px;
  font-weight: bold;
}
.title-div-class{
  font-size: 18px;
  color: #333333;
  border: none;
  padding-bottom: 15px;
}
#runbyhourstatic {
  height: 220px;
}
#dayslineecharts {
  height: 220px;
}
.titleClass {
  margin: 10px 0px 5px 10px;
  font-size: 16px;
  font-weight: bold;
  position: relative;
}

.text-title-class {
  background-color: #52C41A;
  width: 4px;
  height: 15px;
  position: absolute;
  top: 10px;
  left: -10px;
  transform: translateY(-50%);
  content: '';
}

.card-div {
  font-weight: bold;
  font-family: PingFangSC-Regular, PingFang SC;
}

.m-list {
  width: 100%;
  height: auto;
}

.m-list-col {
  width: 100%;
}

.m-list-con {
  color: #333333;
  display: flex;
}

.div1 {
  font-size: 14px;
  font-weight: 400;
  flex-shrink: 0;
  color: #999999;
}
.div2 {
  font-size: 14px;
  font-weight: 400;
  flex: 1;
  padding-left:15px;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contil img {
  width: 100%;
  height: 200px;
  cursor: pointer;
  border-radius: 10px;
}
.tumeline {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.time-class{
  font-size: 14px;
  color: #333333;
  width: 50%;
  margin-top: 5px;
}
.title-div-value{
  color: #999999;
  img{
    width: 12px;
    height: 12px;
  }
}
.div-value{
  color: #333333;
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/elevmonitor.vue